import React, { ComponentClass, FunctionComponent, useContext } from 'react'

import { PluginContext } from '@plugins/index'

interface SlotProps<Props = never> {
  path: string
  FallbackComponent?: FunctionComponent<Props> | ComponentClass<Props> | string
  props?: Props
}

export interface InjectableProps<Props = never> {
  PluginComponent?: FunctionComponent<Props>
  OriginalComponent?: FunctionComponent<Props>
}

export const EmptySlot = () => null

const PluginSlot = <Props = never,>({ path, FallbackComponent, props }: SlotProps<Props>) => {
  const { components, plugin } = useContext(PluginContext)
  const Component =
    components[path] ?? FallbackComponent ?? /* istanbul ignore next: this case will be implemented later */ EmptySlot

  return <Component {...props} OriginalComponent={FallbackComponent} PluginComponent={plugin.components[path]} />
}

export default PluginSlot
